export default {
    logs: {
        fields: {
            number: '№ п/п',
            dateTime: 'Дата и время',
            old: 'Старое значение',
            'new': 'Новое значение',
            userName: 'Логин',
        },

        system: 'система',
        index: 'История события',
    },

    block: 'События',

    cancel: 'Вы уверены что хотите отменить {event}?',
    done: 'Вы уверены что хотите завершить {event}?',

    errorMessage: 'Подробное описание ошибки',

    fields: {
        orderId: 'Номер заказа',
        handler: 'Тип события',
        type: 'Откуда вызвано',
        createdAt: 'Создано',
        updatedAt: 'Обновлено',
        data: 'Сообщение',
    },

    list: 'Автоматическое обновление списка запущено',

    restart: 'Вы уверены что хотите перезапустить {event}?',
    event: 'события | событие',

    actions: 'Действие совершится если оно возможно с событием!',

    checkAll: 'Выбрать все события на текущей странице',
};